import React from 'react';
import SubjectPage from '../structure/SubjectPage';
import Accordions from '../../../components/Dropdowns';

const Workshop = () => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Safety, precautions and maintenance: Safety in shop, safety devices, safety and precautions - moving machine and equipment parts, electrical parts and connections, fire, various driving systems like chain, belt and ropes, electrical accidents, an overview of predictive, preventive and scheduled maintenance, standard guidelines to be followed in shop.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Introduction to machine shop: Introduction to Lathe, Milling, shaper, Planer, grinder, drilling and overview of operations performed on these machines by making some jobs.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Introduction to welding shop: Welding, types of welding, tools and applications, gas welding and arc welding, edge preparation, various joints formation by gas welding and electric arc welding.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Introduction to sheet metal shop: Sheet metal tools and operations, formation of a box using sheet. Introduction to fitting shop: Introduction to fitting, tools and applications, some jobs in fitting shop.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: <Accordions accordionContent={accordionContent} />,
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'videos',
      label: 'Video Lectures',
      content: null, // Managed by SubjectPage
    }
  ];

  return (
    <SubjectPage
      subjectName="Workshop"
      subjectKey="workshop"
      branch="CSE"
      semester="2nd Semester"
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'WorkshopNotes',
        videos: 'WorkshopVideos'
      }}
    />
  );
};

export default Workshop;
